import { concat } from '@ember/helper';
import { capitalize } from '@ember/string';
import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';
interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}

const HistologyCodes = ['CIC', 'CCI', 'CLI', 'CCIS'];

export default class MedicalHistoryFormBreastCancerComponent extends Component<Signature> {
  capitalize = capitalize;

  get histologyCodes(): string[] {
    return HistologyCodes;
  }

  get hormonalPercentageValues(): number[] {
    const values: number[] = [];
    for (let i = 0; i <= 100; i += 10) {
      values.push(i);
    }
    return values;
  }

  <template>
    {{!     HISTOLOGY     }}
    <div class='two fields'>
      <div class='field'>
        <@form.Dropdown
          @labelName='Histologie'
          @propertyName='histology'
          as |dropdown|
        >
          {{#each this.histologyCodes as |key|}}
            <dropdown.Item @key={{key}} @value={{key}} />
          {{/each}}
        </@form.Dropdown>
      </div>
    </div>

    {{!     HORMONAL RECEPTORS     }}

    <div class='two fields'>
      <div class='field'>
        <@form.Dropdown
          @labelName='% Œstrogène'
          @propertyName='estrogenReceptor.percentage'
          as |dropdown|
        >
          {{#each this.hormonalPercentageValues as |value|}}
            <dropdown.Item @key={{value}} @value={{concat value '%'}} />
          {{/each}}
        </@form.Dropdown>
      </div>
      <div class='field'>
        <label for='sdf'>Intensité Œstrogène</label>
        <@form.BasicRadioGroup
          @propertyName='estrogenReceptor.intensity'
          as |Group|
        >
          <div class='fields inline'>
            <div class='field'>
              <Group.Radio
                @label={{this.capitalize
                  (t 'fur.cancer-medical-history.hormoneReceptors' key='low')
                }}
                @value='low'
              />
            </div>
            <div class='field'>
              <Group.Radio
                @label={{this.capitalize
                  (t 'fur.cancer-medical-history.hormoneReceptors' key='medium')
                }}
                @value='medium'
              />
            </div>
            <div class='field'>
              <Group.Radio
                @label={{this.capitalize
                  (t 'fur.cancer-medical-history.hormoneReceptors' key='high')
                }}
                @value='high'
              />
            </div>
          </div>
        </@form.BasicRadioGroup>
      </div>
    </div>

    <div class='two fields'>
      <div class='field'>
        <@form.Dropdown
          @labelName='% Progestérone'
          @propertyName='progesteroneReceptor.percentage'
          as |dropdown|
        >
          {{#each this.hormonalPercentageValues as |value|}}
            <dropdown.Item @key={{value}} @value={{concat value '%'}} />
          {{/each}}
        </@form.Dropdown>
      </div>
      <div class='field'>
        <label for='sdf'>Intensité Progestérone</label>
        <@form.BasicRadioGroup
          @propertyName='progesteroneReceptor.intensity'
          as |Group|
        >
          <div class='fields inline'>
            <div class='field'>
              <Group.Radio
                @label={{this.capitalize
                  (t 'fur.cancer-medical-history.hormoneReceptors' key='low')
                }}
                @value='low'
              />
            </div>
            <div class='field'>
              <Group.Radio
                @label={{this.capitalize
                  (t 'fur.cancer-medical-history.hormoneReceptors' key='medium')
                }}
                @value='medium'
              />
            </div>
            <div class='field'>
              <Group.Radio
                @label={{this.capitalize
                  (t 'fur.cancer-medical-history.hormoneReceptors' key='high')
                }}
                @value='high'
              />
            </div>
          </div>
        </@form.BasicRadioGroup>
      </div>
    </div>

    {{!          }}

    <div class='field'>
      <@form.AlignedFieldsRadioGroup
        @title='HER2'
        @propertyName='her2'
        as |Group|
      >
        <Group.FieldRadio
          @label={{this.capitalize
            (t 'fur.cancer-medical-history.her2' key='positive')
          }}
          @value='positive'
        />
        <Group.FieldRadio
          @label={{this.capitalize
            (t 'fur.cancer-medical-history.her2' key='negative')
          }}
          @value='negative'
        />
      </@form.AlignedFieldsRadioGroup>
    </div>

    <div class='field'>
      <@form.AlignedFieldsRadioGroup
        @title='Récidive'
        @propertyName='relapse'
        as |Group|
      >
        <Group.FieldRadio @label='Oui' @value={{true}} />
        <Group.FieldRadio @label='Non' @value={{false}} />
      </@form.AlignedFieldsRadioGroup>
    </div>

    <div class='field'>
      <@form.AlignedFieldsRadioGroup
        @title='Triple négatif'
        @propertyName='tripleNegative'
        as |Group|
      >
        <Group.FieldRadio @label='Oui' @value={{true}} />
        <Group.FieldRadio @label='Non' @value={{false}} />
      </@form.AlignedFieldsRadioGroup>
    </div>

    <div class='field'>
      <@form.AlignedFieldsRadioGroup
        @title='Préservation de la fertilité'
        @propertyName='fertilityPreservation'
        as |Group|
      >
        <Group.FieldRadio @label='Oui' @value={{true}} />
        <Group.FieldRadio @label='Non' @value={{false}} />
      </@form.AlignedFieldsRadioGroup>
    </div>

    <div class='field'>
      <@form.AlignedFieldsRadioGroup
        @title='Consultation en oncogénétique'
        @propertyName='oncogeneticConsultation'
        as |Group|
      >
        <Group.FieldRadio @label='Oui' @value='yes' />
        <Group.FieldRadio @label='Non' @value='no' />
        <Group.FieldRadio @label='A prévoir' @value='isExpected' />
      </@form.AlignedFieldsRadioGroup>
    </div>

    <div class='field'>
      <@form.AlignedFieldsRadioGroup
        @title='Échographie pelvienne'
        @propertyName='pelvicSonogram'
        as |Group|
      >
        <Group.FieldRadio @label='Normal' @value='normal' />
        <Group.FieldRadio @label='Anormal' @value='abnormal' />
        <Group.FieldRadio @label='N/A' @value='not-applicable' />
      </@form.AlignedFieldsRadioGroup>
    </div>
    <div class='four wide field'>
      <@form.NumberInput
        @labelName='KI-67 (%)'
        @type='integer'
        @min='0'
        @max='100'
        @propertyName='ki67'
      />
    </div>
  </template>
}
